module.exports = __webpack_public_path__ + "img/time_line_circular_arrow_head.608959b3.svg";